import React, {useEffect, useState} from 'react'
import {getByIdResource, getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileLanguageForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [foreignLanguages, setForeignLanguages] = useState([])
    const [knowledgeLevels, setKnowledgeLevels] = useState([])
    const [otherLanguage, setOtherLanguage] = useState(false)

    const [showError, setShowError] = useState(false)
    const [showOtherLanguageError, setShowOtherLanguageError] = useState(false)
    const [showLevelReadingError, setShowLevelReadingError] = useState(false)
    const [showLevelSpeakingError, setShowLevelSpeakingError] = useState(false)
    const [showLevelWritingError, setShowLevelWritingError] = useState(false)


    const constrictCyrillicValues = (e) => {
        const re = /[АБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ абвгдѓежзѕијклљмнњопрстќуфхцчџшш:]+/g;
        if (!re.test(e.key)) {
            e.preventDefault();
        }
    };


    useEffect (() => {
        setEntity(entityTemp)
        if(entityTemp.candidate){
            getByIdResource('foreign_languages/get_by_candidate', entityTemp.candidate.id).then((data) => {
                console.log(`foreign_languages`)
                console.log(data.data)
                setForeignLanguages(data.data)
            })
        }
        getResource('language_knowledge_levels').then((data) => {
            console.log(` language_knowledge_levels`)
            console.log(data.data)
            setKnowledgeLevels(data.data)
        })
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-lg-10 offset-lg-1">
                            {(foreignLanguages && foreignLanguages.length > 0) &&
                                (
                                    <Combo
                                        placeholder="Странски јазик"
                                        tooltipText="Одберете странски јазик"
                                        comboClass="combo-form"
                                        entity={(entity.foreignLanguage) && entity.foreignLanguage.name}
                                        onChange={(e) => {
                                            let chosenForeignLanguage = {};
                                            chosenForeignLanguage.id = e.target.value;
                                            setEntity({ ...entity, foreignLanguage: chosenForeignLanguage })
                                            setShowError(false)
                                            let el = foreignLanguages.find(el => el.id.toString() === chosenForeignLanguage.id.toString());
                                            setOtherLanguage(el.other)
                                        }}
                                        onClear={() => setEntity({...entity, foreignLanguage:null})}
                                        array={foreignLanguages}/>)}

                            {showError && <b>Ве молиме одберете јазик</b>}

                            {(otherLanguage || (entity.otherLanguage && entity.otherLanguage.length > 0 ))&&
                                <input className="input-form w-100" type="text" placeholder="Друг јазик"
                                                     value={entity.otherLanguage}
                                                     onKeyPress={(e) => constrictCyrillicValues(e)}
                                                     onChange={(e) => {
                                                         setEntity({...entity, otherLanguage: e.target.value})
                                                         setShowOtherLanguageError(false)
                                                     }}
                            />}
                            {showOtherLanguageError && <b>Ве молиме внесете јазик</b>}

                            {(knowledgeLevels && knowledgeLevels.length > 0) &&
                                <Combo
                                    placeholder="Ниво на читање"
                                    tooltipText="Одберете ниво на читање"
                                    comboClass="combo-form"
                                    entity={(entity.languageReadingLevel) && entity.languageReadingLevel.name}
                                    onChange={(e) => {
                                        let chosenListening = {};
                                        chosenListening.id = e.target.value;
                                        setEntity({ ...entity, languageReadingLevel: chosenListening })
                                        setShowLevelReadingError(false)
                                    }}
                                    onClear={() => setEntity({...entity, languageReadingLevel:null})}
                                    array={knowledgeLevels}/>}
                            {showLevelReadingError && <b>Ве молиме одберете ниво на читање</b>}

                            {(knowledgeLevels && knowledgeLevels.length > 0) &&
                                <Combo
                                    placeholder="Ниво на зборување"
                                    tooltipText="Одберете ниво на зборување"
                                    comboClass="combo-form"
                                    entity={(entity.languageSpeakingLevel) && entity.languageSpeakingLevel.name}
                                    onChange={(e) => {
                                        let chosenListening = {};
                                        chosenListening.id = e.target.value;
                                        setEntity({ ...entity, languageSpeakingLevel: chosenListening })
                                        setShowLevelSpeakingError(false)
                                    }}
                                    onClear={() => setEntity({...entity, languageSpeakingLevel:null})}
                                    array={knowledgeLevels}/>}
                            {showLevelSpeakingError && <b>Ве молиме одберете ниво на зборување</b>}
                            {(knowledgeLevels && knowledgeLevels.length > 0) &&
                                <Combo
                                    placeholder="Ниво на пишување"
                                    tooltipText="Одберете ниво на пишување"
                                    comboClass="combo-form"
                                    entity={(entity.languageWritingLevel) && entity.languageWritingLevel.name}
                                    onChange={(e) => {
                                        let chosenListening = {};
                                        chosenListening.id = e.target.value;
                                        setEntity({ ...entity, languageWritingLevel: chosenListening })
                                        setShowLevelWritingError(false)
                                    }}
                                    onClear={() => setEntity({...entity, languageWritingLevel:null})}
                                    array={knowledgeLevels}/>}
                            {showLevelWritingError && <b>Ве молиме одберете ниво на пишување</b>}



                            <div className="d-flex justify-content-between">

                                <div
                                    className="btn-form"
                                    onClick={()=>
                                    {setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори</div>
                                <div
                                    className="btn-form"
                                    onClick={(e) => {
                                        if(otherLanguage && (!entity.otherLanguage || entity.otherLanguage === "")){
                                            setShowOtherLanguageError(true)
                                        }else if(!entity.foreignLanguage || entity.foreignLanguage.id === "0"){
                                            setShowError(true)
                                        } else if (!entity.languageReadingLevel || entity.languageReadingLevel.id === "0") {
                                            setShowLevelReadingError(true)
                                        } else if (!entity.languageSpeakingLevel || entity.languageSpeakingLevel.id === "0") {
                                            setShowLevelSpeakingError(true)
                                        } else if (!entity.languageWritingLevel || entity.languageWritingLevel.id === "0") {
                                            setShowLevelWritingError(true)
                                        } else {
                                            updateResource('candidates_foreign_language', entity)
                                                .then((data) => {
                                                    console.log(data.data)
                                                    setAddEntity(false)
                                                    setEntityTemp({candidate: entity.candidate})
                                                    setUpdateEntity(!updateEntity)
                                                    setShowError(false)
                                                    setShowLevelReadingError(false)
                                                    setShowLevelSpeakingError(false)
                                                    setShowLevelWritingError(false)
                                                })
                                        }
                                    }}
                                >Зачувај</div>
                            </div>
                        </div>
            </>
            )
                }
        </div>
    )
}